import { render, staticRenderFns } from "./CartItemsCount.vue?vue&type=template&id=4ea22ed0&"
import script from "./CartItemsCount.vue?vue&type=script&lang=ts&"
export * from "./CartItemsCount.vue?vue&type=script&lang=ts&"
import style0 from "./CartItemsCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports